// When a user clicks on the Tudor menu button, toggle between showing & hiding the dropdown menu
function myFunction() {
  document.getElementById("tudorDropdown").classList.toggle("show");
}

// Close the Tudor dropdown menu if the user clicks outside of it
window.onclick = function(event) {
  if (!event.target.matches('.tudorMenuButton')) {
    var dropdowns = document.getElementsByClassName("tudorMenuDropdownContent");
    var i;
    for (i = 0; i < dropdowns.length; i++) {
      var openDropdown = dropdowns[i];
      if (openDropdown.classList.contains('show')) {
        openDropdown.classList.remove('show');
      }
    }
  }
}